/* eslint-disable max-lines-per-function */
import React, { useRef } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import grupoTvService from '../../../../services/tvs/grupoTvService.js';
import { InputText } from 'primereact/inputtext';
import { Growl } from 'primereact/growl';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { validacaoFormGrupo } from '../helpers/validacao';
import { mostrarMensagemSucesso, mostrarMensagemErro } from '../../shared/getMensagens';

export function EditarGruposTvs({
    rowSelecionada,
    modalEdicaoAberto,
    setModalEdicaoAberto,
    setRecarregarDataTable
}) {
    const mensagemToast = useRef(null);

    const fecharModal = () => setModalEdicaoAberto(false);
    const valoresIniciaisFrupo = {
        nome: rowSelecionada.nome,
        tempoExecucao: rowSelecionada.tempoExecucao        
    };
    
    const editarGrupo = async values => {
        try {
            await grupoTvService.putGrupo(values, rowSelecionada.id);
            fecharModal();
            setRecarregarDataTable(true);
            mostrarMensagemSucesso(mensagemToast,'Grupo alterado com sucesso!');
        } catch (error) {
            mostrarMensagemErro(mensagemToast,'Não foi possível alterar os dados! Tente novamente mais tarde.');
            throw new Error(error);
        }
    };

    return (
        <>
            <Growl ref={mensagemToast} />
            <Dialog
                visible={modalEdicaoAberto}
                header={'Editar Grupos de Programação'}
                dismissableMask
                onHide={fecharModal}
                
            >
                    
                <Formik                        
                    onSubmit={editarGrupo}
                    initialValues={valoresIniciaisFrupo}
                    validationSchema={validacaoFormGrupo}
                >
                    {({ values, touched }) => (
                        <Form className="form-wrapper">
                            <div className="content-wrapper">
                                <div className="form-item">
                                    <div className="form-item-label">
                                        <label htmlFor="nome">
                                                    Nome do Grupo
                                        </label>
                                    </div>
                                    <Field
                                        as={InputText}
                                        id="nome"
                                        name="nome"
                                        type="text"
                                        size={30}
                                        maxLength={60}
                                        value={values.nome}
                                    />
                                    <div className="form-item-label">
                                        <label htmlFor="nome">Tempo de Execucao (Segundos)</label>
                                    </div>
                                    <Field
                                        as={InputText}
                                        id="tempoExecucao"
                                        name="tempoExecucao"
                                        type="number"
                                        size={30}
                                        maxLength={60}
                                    />

                                    <ErrorMessage
                                        className="error-message"
                                        name="nome"
                                        component="div"
                                    />
                                </div>                                    
                            </div>
                            <div className="edit-button">
                                <Button
                                    style={{ width: '95px' }}
                                    label="Editar"
                                    icon="pi pi-caret-right"
                                    iconPos="right"
                                    disabled={
                                        touched.nome || touched.tempoExecucao ?
                                            false :
                                            true
                                    }
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
                
            </Dialog>
        </>
    );
}
